"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var lodash_1 = require("lodash");
var facet_utils_1 = require("../facet_utils");
var search_filters_1 = require("./search_filters");
var filter_link_1 = require("./filter_link");
var user_context_provider_1 = require("./user_context_provider");
var WIDGET_CONFIGS = (_a = {},
    _a[search_filters_1.WidgetType.RANGE] = rangePillConfig,
    _a[search_filters_1.WidgetType.NESTED_SELECT] = nestedPillConfig,
    _a[search_filters_1.WidgetType.CHECKBOX] = defaultPillConfig,
    _a[search_filters_1.WidgetType.REGION_SELECT] = regionPillConfig,
    _a[search_filters_1.WidgetType.RADIO] = defaultPillConfig,
    _a[search_filters_1.WidgetType.TEXT] = defaultPillConfig,
    _a[search_filters_1.WidgetType.SORT] = function (_filter) { return []; },
    _a);
function regionPillConfig(filter, user) {
    var opts = filter.options.filter(function (opt) { return opt.selected &&
        !opt.all &&
        opt.optionValue !== user.shippingRegionCode; });
    return opts.map(function (opt) {
        var _a;
        return {
            key: opt.paramName,
            terms: [
                {
                    name: I18n.t("commons.pills." + opt.paramName, { region: opt.name }),
                    params: (_a = {}, _a[opt.paramName] = opt.unsetValues, _a)
                }
            ],
        };
    });
}
function nestedPillConfig(filter, _user) {
    var terms = facet_utils_1.selectedPath(filter);
    if (terms.length === 0) {
        return [];
    }
    if (terms.length === 1 && terms[0].all) {
        return [];
    }
    var termOptions = terms.map(function (opt) {
        var _a;
        return {
            name: opt.name,
            params: (_a = {}, _a[opt.paramName] = opt.unsetValues, _a),
        };
    });
    return [
        {
            key: terms[0].paramName,
            terms: termOptions
        }
    ];
}
function rangePillConfig(filter, _user) {
    var displayOption = filter.options[2];
    if (!displayOption || !displayOption.selected) {
        return [];
    }
    return [
        {
            key: filter.options[0].paramName,
            terms: [
                {
                    name: displayOption.name,
                    params: search_filters_1.getRangeUnsetParams(filter),
                }
            ]
        }
    ];
}
function defaultPillConfig(filter, _user) {
    var selectedOpts = filter.options.filter(function (opt) { return opt.selected && !opt.all; });
    return selectedOpts.map(function (opt) {
        var _a;
        return {
            key: "" + opt.paramName + opt.optionValue,
            terms: [
                {
                    name: opt.name,
                    params: (_a = {}, _a[opt.paramName] = opt.unsetValues, _a)
                }
            ]
        };
    });
}
function filtersToPills(filters, user) {
    return filters.reduce(function (acc, filter) {
        var configFn = lodash_1.get(WIDGET_CONFIGS, filter.widgetType, defaultPillConfig);
        return acc.concat(configFn(filter, user));
    }, []);
}
function Pill(props) {
    return (React.createElement("div", { className: "search-pill" }, props.terms.map(function (opt, idx) {
        return (React.createElement("div", { className: "search-pill__term", key: idx },
            opt.name,
            React.createElement(filter_link_1.default, { params: opt.params, className: "search-pill__remove", rel: "nofollow" })));
    })));
}
var RQLPills = /** @class */ (function (_super) {
    tslib_1.__extends(RQLPills, _super);
    function RQLPills() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RQLPills.prototype.pills = function () {
        return filtersToPills(this.props.filters, this.context.user);
    };
    RQLPills.prototype.render = function () {
        var pills = this.pills();
        if (pills.length === 0) {
            return null;
        }
        return (React.createElement("ul", { className: "search-pills" },
            React.createElement("li", { className: "search-pills__label" }, I18n.t('commons.pills.filteredBy')),
            pills.map(function (pill) { return React.createElement(Pill, { terms: pill.terms, key: pill.key }); })));
    };
    RQLPills = tslib_1.__decorate([
        user_context_provider_1.WithUserContext
    ], RQLPills);
    return RQLPills;
}(React.Component));
exports.default = RQLPills;
//# sourceMappingURL=rql_pills.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/rql_pills.js
// module id = QRb7
// module chunks = 0 1 2 3 4 9 10 14 20